import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Input,
  Row,
  Col,
  CardTitle,
} from "reactstrap";
import useToken from "../../helpers/useToken";
import TMHLoader from "../TMHLoader/TMHLoader";
import UploadImg from "./upload.png";
import { utils_StringIsNullOrEmpty } from "helpers/utils";

export default function RokuRemoteMobileConfig({ notify }) {
  const { token } = useToken();
  const [config, setConfig] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const initData = () => {
      setIsLoading(true);
      console.log("RokuRemoteMobileConfig:: get data");
      const myHeaders = new Headers();
      myHeaders.append("Cache-Control", "no-cache");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      fetch(
        process.env.REACT_APP_BASE_URL + "roku_remote/mobile_config",
        requestOptions
      )
        .then((response) => {
          return new Promise((resolve) =>
            response.json().then((json) =>
              resolve({
                status: response.status,
                ok: response.ok,
                json,
              })
            )
          );
        })
        .then((result) => {
          var json = result.json;
          // console.log(json)
          if (result.ok) {
            setConfig(json.data);
          } else {
            // console.log(result.json.message)
          }
          setIsLoading(false);
        });
    };

    initData();
  }, [token]);

  const uploadImage = (e, index) => {
    setIsLoading(true);
    console.log("RokuRemoteMobileConfig: uploadImage");
    const myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);

    const formData = new FormData();
    formData.append("image", e.target.files[0]);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
    };

    fetch(process.env.REACT_APP_BASE_URL + "image/upload", requestOptions)
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then(async (result) => {
        if (result.ok && result.json.image) {
          config.channels[index].logo = result.json.image;
          setConfig({
            ...config,
            channels: config.channels,
          });
        } else {
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleUpdateConfig = async () => {
    setIsLoading(true);
    console.log("RokuRemoteMobileConfig: PUT data");
    const myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify({
        data: config,
      }),
    };

    fetch(
      process.env.REACT_APP_BASE_URL + "roku_remote/mobile_config",
      requestOptions
    )
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then(async (result) => {
        var json = result.json;
        // console.log(json)
        if (result.ok) {
          setConfig(json.data);
          notify("tl", "Save Config List Success!", "success");
        } else {
          // console.log(result.json.message)
          notify("tl", "Save Config List Failed: !" + json?.message, "danger");
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <TMHLoader active={isLoading}>
      <Card>
        <CardHeader>
          <CardTitle className="text-center" tag="h2">
            Roku Remote Config
          </CardTitle>
        </CardHeader>
        <CardBody className="text-white">
          <h4>Channels: </h4>
          <div className="my-4" style={{ display: "flex", flexWrap: "wrap" }}>
            {config?.channels?.map((channel, index) => (
              <div className="p-3">
                <Input
                  style={{ display: "none" }}
                  id={"img_upload_" + index}
                  type="file"
                  accept="image/*"
                  onChange={(e) => uploadImage(e, index)}
                />
                <label
                  for={"img_upload_" + index}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={
                      utils_StringIsNullOrEmpty(channel.logo)
                        ? UploadImg
                        : channel.logo
                    }
                    alt="channel-img"
                    style={{ width: 290, height: 218 }}
                  />
                </label>

                <Input
                  style={{ width: 290 }}
                  placeholder="Channel Name"
                  type="text"
                  value={channel.name}
                  onChange={(e) => {
                    config.channels[index].name = e.target.value;
                    setConfig({
                      ...config,
                      channels: config.channels,
                    });
                  }}
                />
                <Input
                  style={{ width: 290 }}
                  placeholder="Channel Id"
                  type="text"
                  value={channel.id}
                  onChange={(e) => {
                    config.channels[index].id = e.target.value;
                    setConfig({
                      ...config,
                      channels: config.channels,
                    });
                  }}
                />
              </div>
            ))}
            <div className="my-4">
              <Button
                onClick={() => {
                  config.channels.push({
                    id: "",
                    logo: "",
                    name: "",
                  });
                  setConfig({
                    ...config,
                    channels: config.channels,
                  });
                }}
                className="btn-icon btn-simple"
                color="success"
                size="sm"
              >
                <i className="fa-solid fa-copy" />
              </Button>
              <Button
                onClick={() => {
                  config.channels.pop();
                  setConfig({
                    ...config,
                    channels: config.channels,
                  });
                }}
                className="btn-icon btn-simple"
                color="danger"
                size="sm"
              >
                <i className="fa-solid fa-square-minus"></i>
              </Button>
            </div>
          </div>
          <Row className="text-center">
            <Col md="12">
              <Button onClick={() => handleUpdateConfig()} color="success">
                Update
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </TMHLoader>
  );
}
